import {
  type Appointment,
  type Client,
  type MessageContext,
  type Service,
  appointmentMessage,
  defaultMessageKind,
  whatsappUrl,
} from '@lindeza/core';
import { useProfessional, useRuntime, useTemplates } from '@lindeza/core/hooks';
import { useMemo } from 'react';

/** Contexto das mensagens prontas (perfil, link e modelos editados). */
export function useMessageCtx(): MessageContext | null {
  const rt = useRuntime();
  const prof = useProfessional();
  const templates = useTemplates();
  return useMemo(
    () => (prof ? { professional: prof, baseUrl: rt.publicBaseUrl, templates: templates ?? [] } : null),
    [prof, templates, rt.publicBaseUrl],
  );
}

export type MessageKindForAppointment = 'confirmation' | 'reminder' | 'reschedule' | 'delay' | 'post_service';

/** Abre o WhatsApp com a mensagem pronta (1 toque). */
export function openWhatsapp(phone: string | null | undefined, text: string): void {
  window.open(whatsappUrl(phone, text), '_blank', 'noopener');
}

export function messageFor(
  ctx: MessageContext,
  kind: MessageKindForAppointment | 'auto',
  appointment: Appointment,
  client: Client | undefined,
  service: Service | undefined,
  extra: Record<string, string> = {},
): string {
  const k = kind === 'auto' ? defaultMessageKind(appointment, ctx.professional.timezone) : kind;
  return appointmentMessage(
    k,
    ctx,
    appointment,
    client ?? { name: 'cliente', access_code: null },
    service ?? null,
    k === 'delay' ? { minutos: '10', ...extra } : extra,
  );
}
